import * as Roles from "../constants/roles";
import * as Permissions from "../constants/permissions";
import auth_util from "./../utils/auth";
import RoleUtils from "@/utils/role";

export default {
    data() {
        return {
            Roles,
            Permissions,
            permissionMap: [
                {
                    permission: Permissions.EDIT_ORDER,
                    roles: [Roles.ADMIN, Roles.SUPER_ADMIN],
                },
                {
                    permission: Permissions.EDIT_ORDER_TRACKING,
                    roles: [Roles.ADMIN, Roles.SUPER_ADMIN, Roles.EMPLOYEE],
                },
            ],
        };
    },
    computed: {
        auth() {
            return {
                user: this.$store.state.user,
                role: _.get(this.$store.state.user, "roles.0"),
                permissions: _.get(this.$store.state.user, "permissions"),
            };
        },
    },
    methods: {
        can(permission) {
            return this.auth.permissions.includes(permission);
        },
        hasRole(role) {
            return auth_util.hasRole(role);
        },
        getRoleName(role) {
            return RoleUtils.getRoleName(role);
        },
    },
};
